import React from "react";

interface SectionHeadingProps {
  children: React.ReactNode;
  /** White type, for the sections that sit on navy or the gradient card. */
  onDark?: boolean;
}

const SectionHeading: React.FC<SectionHeadingProps> = ({
  children,
  onDark = false,
}) => (
  <h2
    className={`text-3xl font-extrabold leading-tight tracking-tight md:text-5xl ${
      onDark ? "text-white" : "text-gray-900 dark:text-white"
    }`}
  >
    {children}
  </h2>
);

export default SectionHeading;
